import { CircleButton } from "../Button";
import { AngleTopIcon } from "../Icon";
import { useScrollState } from "./hooks";
import { motion } from "framer-motion";
import cls from "./styles.module.css";

export default function TopScrollFab() {
  const { progress } = useScrollState();
  const onClick = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <motion.div
      aria-hidden
      className={cls.root}
      style={{
        opacity: progress,
      }}
    >
      <CircleButton tabIndex={-1} title="Наверх" onClick={onClick}>
        <AngleTopIcon size={24} />
      </CircleButton>
    </motion.div>
  );
}
